import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthFacade } from 'src/app/core/store/auth/auth.facade';
import { SnackBarService } from './../layout/snackbar.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private snackBarService: SnackBarService,
    private authFacade: AuthFacade
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authFacade.logout();

          this.router.navigate(['/auth/login']);
          this.snackBarService.open(
            {
              type: 'error',
              message:
                'Acesso não autorizado. Tente entrar novamente na sua conta.',
            },
            { duration: 5000 }
          );
        }

        return throwError(error);
      })
    );
  }
}
